import { faTrophy } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM, LabelS, LabelXS } from '@sorare/core/src/atoms/typography';
import { Ordinal } from '@sorare/core/src/atoms/typography/Ordinal';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { NewAnyRewardConfig, Variant } from '../NewAnyRewardConfig';

const EntryFeeContainer = styled(SBHorizontal)`
  padding: var(--intermediate-unit) var(--double-unit);
  border-radius: 16px;
  border: 1px solid var(--c-nd-50);
  background: #312300;
  backdrop-filter: blur(16px);
  gap: var(--unit);
`;

const gradientYellowText = css`
  background: linear-gradient(
    218deg,
    #fff 1.37%,
    #fcff63 36.66%,
    #c26900 101.57%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const StyledHeadlineM = styled(HeadlineM)`
  ${gradientYellowText}
`;

const StyledLabelS = styled(LabelS)`
  ${gradientYellowText}
`;

const Sup = styled(LabelXS).attrs({
  brand: true,
  bold: true,
})`
  display: inline-block;
  vertical-align: super;
`;

export const SpecialRoomReward = ({
  selectedSo5LeaderboardSlug,
}: {
  selectedSo5LeaderboardSlug?: string;
}) => {
  const {
    flags: { allInArenaConfig = {} },
  } = useFeatureFlags();
  const allInArenaRoomConfig = allInArenaConfig.roomConfigBySo5LeaderboardSlug
    ? allInArenaConfig.roomConfigBySo5LeaderboardSlug[
        selectedSo5LeaderboardSlug || ''
      ]
    : undefined;
  if (!allInArenaRoomConfig) {
    return null;
  }
  return (
    <EntryFeeContainer>
      <SBHorizontal grow>
        <Vertical gap={0.5}>
          <Horizontal>
            <HeadlineM>
              <FontAwesomeIcon icon={faTrophy} color="var(--c-yellow-400)" />
            </HeadlineM>
            <StyledHeadlineM brand>
              <Ordinal ordinal={1} Sup={Sup} />
            </StyledHeadlineM>
          </Horizontal>
          <StyledLabelS>
            <FormattedMessage
              id="SpecialRoomReward.rewardForGoldenRooms"
              defaultMessage="*Reward for {count} Golden Rooms"
              values={{
                count: allInArenaRoomConfig?.specialRooms?.count,
              }}
            />
          </StyledLabelS>
        </Vertical>
        <NewAnyRewardConfig
          variant={Variant.CHIP}
          anyRewardConfig={{
            __typename: 'CardShardRewardConfig',
            id: 'normalized-card-shard-reward-config',
            quantity: allInArenaRoomConfig?.specialRooms?.cardShards?.quantity,
            rarity: allInArenaRoomConfig?.specialRooms?.cardShards?.rarity,
          }}
          afterText="*"
        />
      </SBHorizontal>
    </EntryFeeContainer>
  );
};
